import React from 'react';
import { Link } from "react-router-dom";
import CompareSvg from "../../../images/compare-button.svg";
import Button from '../../../new/Utils/Button';
import { useMobileStatus } from '../../../new/Utils/useMobileStatus';

const CompareAssessmentsButton = () => {
  const isMobile = useMobileStatus();
  
  return (
    <div>
      <Link
        to="/new/app/assessment"
        style={{ textDecoration: "none" }}
      >
        <Button
          type="submit"
          style={{
            width: isMobile ? 'min-content' : "fit-content",
            display: "flex",
            alignItems: "center",
          }}
        >
          <img
            src={CompareSvg}
            alt="Compare Icon"
            style={{ marginRight: "10px" }}
          />
          COMPARE ASSESSMENTS
        </Button>
      </Link>
    </div>
  );
};

export default CompareAssessmentsButton;


// WEBPACK FOOTER //
// ./src/_components/common/CompareAssessmentsButton/CompareAssessmentsButton.jsx